var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
define(["require", "exports", "./browser-detection", "./mobile-detection", "./touch-detection"], function (require, exports, BrowserDetection, MobileDetection, TouchDetection) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    BrowserDetection = __importStar(BrowserDetection);
    MobileDetection = __importStar(MobileDetection);
    TouchDetection = __importStar(TouchDetection);
    exports.BrowserDetection = BrowserDetection;
    exports.MobileDetection = MobileDetection;
    exports.TouchDetection = TouchDetection;
});
